import React, { useState, Context, ReactElement, Component } from "react";

export interface namespaces_type {
    kind: string;
    items: namespaces_type_item[];
}

export interface namespaces_type_item {
    key?: string;
    metadata: {
        name: string;
        key: string;
        uid: string;
        isSelected: number;
        selfLink: string;
        resourceVersion: string;
        quota: string;
        generation: number;
        creationTimestamp: string;
        labels?: {
            namespacequota: string;
            user: string;
            workspace: string;
        };
        annotations: {
            creator: string;
        }
        persistent_volume_claims: string,
        cronjobs_batch: string,
        daemonsets_apps: string,
        deployments_apps: string,
        ingresses_extensions: string,
        jobs_batch: string,
        pods: string,
        services: string,
        statefulsets_apps: string,
        usedCPU: string;
        usedMemory: string;
        usedRootfs: string;
        usedPod: string;
        usedDisk: string;
        usedGPU: string;
        totalCPU: string;
        totalMemory: string;
        totalRootfs: string;
        totalPod: string;
        totalDisk: string;
        totalGPU: string;
        totalNamespaces: string;
        usedSecret: string;
        usedConfigmap: string;
        usedService: string;
        requestCPU: string;
        requestMemory: string;
        limitCPU: string;
        limitMemory: string;
        uptime: string;
    };

    spec: {
        finalizers: string[];
        description: string;
        cpulimitused: string;
        memorylimitlused: string;
        namespaces: object[];
    };
    status?: {
        phase: string;
    };
}

const NamespaceContext: Context<[namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>]> = React.createContext<[namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>]>([undefined, (_value: any) => { }]);

const NamespaceProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useState();
    return (
        <NamespaceContext.Provider value={[namespaces, set_namespaces]}>
            {props.children}
        </NamespaceContext.Provider>
    )
}

export { NamespaceContext, NamespaceProvider };

